export default __webpack_public_path__ + "static/media/2267.2d55d3bd.svg";